export class ApiEndpoints {
    static LOGIN = '/login';
    static REMEMBER_PASSWORD = '/recoverpassword';
    static RESET_PASSWORD = '/setnewpassword';
    static DASHBOARD = '/dashboard';
    static RELATED_CONTRACTORS_DASHBOARD = '/relatedcontractorsdashboard';
    static DOCUMENTS = '/documents';
    static DOCUMENT_ID = '/documents/:id';
    static DOCUMENT_REVISIONS = '/documents/revisions/:id';
    static DOCUMENT_REVISIONS_BATCH = '/documents/revisions';
    static MESSAGES = '/messages';
    static MESSAGE_ID = '/messages/:id';
    static MESSAGES_ARCHIVE_ID = '/messages/archive/:id';
    static MESSAGES_MARK_READ = '/messagesread';
    static MESSAGE_LIST_TARGET_COMPANIES = '/message/targetcompanies';
    static WORKERS = '/workers';
    static WORKERS_STATE = '/workerstates';
    static WORKER_ADD = '/workers';
    static WORKER_ID = '/workers/:id';
    static WORKS = '/constructions';
    static WORK_ID = '/constructions/:id';
    static WORKS_STATE = '/constructionstates';
    static WORKS_RECENTLY_ADDED = '/constructions/latest';
    static WORKS_IMPORT = '/constructionsimport';
    static USERS = '/users';
    static USER_ADD = '/users';
    static USER_ID = '/users/:id';
    static USER_ROLES = '/roles';
    static DOCUMENTS_SCHEMAS = '/documentschemas';
    static DOCUMENTS_SCHEMAS_ID = '/documentschemas/:id';
    static DOCUMENTS_SCHEMAS_BY_CONTRACTOR_AS_COMPANY = '/documentschemasbycontractorascompany';
    static DOCUMENT_STATES = '/documentstates';
    static CURRENT_USER = '/currentuser';
    static COMPANIES = '/companies';
    static COMPANIES_BASIC = '/companiesbasic';
    static COMPANY_ADD = '/companies';
    static COMPANY_ID = '/companies/:id';
    static COMPANIES_IMPORT = '/companiesimport';
    static COMPANIES_EXPORT = '/export-company-documents/:id';
    static BATCH_DELETE = '/batch-delete';
    static COMPANY_ASSOCIATION_ADD = '/companyassociation/:nif';
    static MACHINES = '/machines';
    static MACHINES_STATE = '/machinestates';
    static MACHINE_ADD = '/machines';
    static MACHINE_ID = '/machines/:id';
    static MACHINE_TYPES = '/machinetypes';
    static NOTIFICATIONS = '/notifications';
    static NOTIFICATIONS_MARK_READ = '/notificationsread';
    static NOTIFICATIONS_MARK_RESOLVED = '/notificationssolved';
    static DOCUMENTS_TYPE = '/documenttypes';
    static DOCUMENT_TYPE_ID = '/documenttypes/:id';
    static FYLE_TYPE = '/filetypes';
    static UPLOAD = '/upload';
    static MONTLY_YEARS = '/workchecks/years';
    static MONTLY_MONTHS = '/workchecks/months';
    static MONTLY_WORK_CHECK_STATES = '/workchecks/workcheckstates';
    static MONTLY_WORK_CHECK_TYPES = '/workchecks/workchecktypes';
    static MONTLY_WORK_CHECKS = '/workchecks/workchecks';
    static MONTLY_WORK_CHECK = '/workchecks/workmonthcheck';
    static MONTLY_WORK_CHECK_BATCH = '/workchecks/workmonthchecks';
    static MONTLY_WORK_CHECK_EXPORT = '/workchecks/export';
    static TASKS = '/tasks';
    static TASK_STATES = '/taskstates';
    static TASK_CHANGE_STATE = '/changestatetask/:id';
    static TASK_LINK_DOCUMENTS = '/tasklinkdocuments';
    static TASK_SEND_EMAIL = '/sendemailtask/:id';
    static TASK_IMPORT = '/importtask';
    static TASK_ADD = '/tasks';
    static CONTRACTORS = '/contractors'; // POST
    static CONTRACTORS_RELATED = '/relatedcontractors'; // POST
    static CONTRACTORS_BASIC = '/contractorsbasic'; // POST
    static CONTRACTORS_DETAIL = '/contractors/:id'; // GET
    static CONTRACTORS_DETAIL_CURRENT = '/currentcontractor'; // GET
    static CONTRACTORS_ADD = '/contractors'; // PUT
    static CONTRACTORS_UPDATE = '/contractors/:id'; // POST
    static CONTRACTORS_DELETE = '/contractors/:id'; // DELETE
    static BATCH_RESTORE = '/batch-restore';
    static WORKER_CONSTRUCTION_PRESENCES = '/workerconstructionpresences';
    static WORKER_CONSTRUCTION_PRESENCE_DETAIL = '/workerconstructionpresences/:id';
    static WORKER_CONSTRUCTION_PRESENCE_UPDATE = '/workerconstructionpresences/:id';
    static WORKER_CONSTRUCTION_PRESENCE_DELETE = '/workerconstructionpresences/:id';
    static WORKER_CONSTRUCTION_PRESENCE_ADD = '/workerconstructionpresences';
    static WORKER_CONSTRUCTION_PRESENCE_ADD_IN_BATCH = '/workerconstructionpresencesbatch';
    static MONTHLY_PRESENCE_YEARS = '/workerconstructionpresence/years';
    static MONTHLY_PRESENCE_MONTHS = '/workerconstructionpresence/months';
    static CONTRACTOR_FILES = '/contractorfiles';
    static CONTRACTOR_FILES_ADD = '/contractorfiles';
    static CONTRACTOR_FILES_ID = '/contractorfiles/:id';
    static CONTRACTOR_FILES_DELETE = '/contractorfiles/:id';
    static CONTRACTORS_OF_CONTRACTOR_FILES = '/contractorsofcontractorfiles';
    static WORKER_QR_TOKEN = '/qrworkertoken/encode/:contractorId/:id';
    static MACHINE_QR_TOKEN = '/qrmachinetoken/encode/:contractorId/:id';
    static OUTSOURCES_EXPORT = '/companiesexport';
    static SEND_COMPANY_WORKER_MISSING_INFO_EMAIL = '/sendcompanyworkermissinginfoemail/:id';
    static SEND_COMPANY_MACHINE_MISSING_INFO_EMAIL = '/sendcompanymachinemissinginfoemail/:id';
    static WORKERS_EXPORT = '/workersexport';
    static MACHINES_EXPORT = '/machinesexport';
    static NOTIFICATIONS_EXPORT = '/notificationsexport';
}



// WEBPACK FOOTER //
// ./src/app/shared/webservices/endpoint.js